import * as zod from 'zod';

// NOTE "completedCount" and "currentActivity" are handled in the parent step
export default zod.object({});
